import { render, staticRenderFns } from "./Adventures.vue?vue&type=template&id=6ec7ba54&scoped=true&"
import script from "./Adventures.vue?vue&type=script&lang=js&"
export * from "./Adventures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7ba54",
  null
  
)

export default component.exports